var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoneInfluenceXs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 636,
    viewBox: "0 0 636 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.783 165.217C350.338 166.087 371.643 169.519 386.501 174.681C393.961 177.273 399.17 180.086 402.295 182.779C405.425 185.475 405.779 187.379 405.607 188.499C405.387 189.929 404.031 192.306 399.675 195.18C395.461 197.961 389.195 200.69 380.921 203.089C364.403 207.879 342.062 210.735 318.348 210.983C294.643 211.23 271.624 208.849 253.901 204.394C245.031 202.164 237.997 199.542 232.953 196.766C227.754 193.903 225.381 191.269 224.634 189.394C224.116 188.095 224.124 186.549 226.196 184.235C228.451 181.717 232.747 178.889 239.515 176.166C252.956 170.758 273.298 166.89 296.592 165.531",
    stroke: "current",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.305 165.037C346.985 165.404 371.899 168.518 389.845 173.619C398.849 176.178 405.444 179.054 409.643 181.925C414.017 184.916 414.693 187.09 414.659 188.086C414.621 189.176 413.681 191.467 409.028 194.484C404.579 197.369 397.747 200.222 388.562 202.739C370.244 207.758 345.109 210.749 318.411 210.985C291.723 211.221 265.867 208.683 246.269 203.98C236.456 201.625 228.806 198.868 223.479 195.973C217.916 192.95 215.883 190.322 215.44 188.749C215.183 187.837 215.18 186.12 218.445 183.363C221.73 180.59 227.426 177.658 235.751 174.954C252.303 169.578 276.339 166.029 302.881 165.191",
    stroke: "current",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.668 72.0169C262.319 64.4062 261.788 56.3523 263.118 48.5001C264.447 40.6479 267.601 33.2152 272.326 26.7974C277.051 20.3797 283.216 15.1552 290.329 11.5434C297.441 7.93161 305.303 6.03308 313.284 6.00043C321.264 5.96777 329.141 7.8019 336.283 11.3554C343.425 14.9089 349.634 20.0827 354.411 26.4617C359.189 32.8405 362.403 40.2473 363.797 48.0883C365.191 55.9294 364.726 63.9874 362.44 71.617",
    stroke: "current",
    strokeWidth: 12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M343.548 60.5C343.548 77.3373 329.875 91 312.992 91C296.109 91 282.437 77.3373 282.437 60.5C282.437 43.6627 296.109 30 312.992 30C329.875 30 343.548 43.6627 343.548 60.5Z",
    fill: "#CCB46F",
    stroke: "current",
    strokeWidth: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.416 71L313.994 184.5L362.57 71",
    stroke: "current",
    strokeWidth: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneInfluenceXs);
export default __webpack_public_path__ + "static/media/zone_influence_xs.85c779c0dcfa8b7a06653db7569b3a40.svg";
export { ForwardRef as ReactComponent };